import "core-js/modules/es.number.constructor.js";
import config from 'utils/config';
/*
 * The most decimal places an averaged score can be displayed to. Averaged scores are
 * stored to 2dp, so anything beyond this would only ever render trailing zeros.
 * Mirrors MAX_SCORE_DECIMAL_PLACES in api/utils/helix.js.
 */
export var MAX_SCORE_DECIMAL_PLACES = 2;
export default function getHelixUIMode() {
  var _ref = config || {},
    helixUIMode = _ref.helixUIMode,
    helixShowOverallScore = _ref.helixShowOverallScore,
    helixScoreOutOf = _ref.helixScoreOutOf,
    helixScoreDecimalPlaces = _ref.helixScoreDecimalPlaces;
  var showFeedback = helixUIMode !== 'onlyScores';
  var showScores = helixUIMode !== 'onlyFeedback';
  var showOverallScore = helixShowOverallScore === true;
  var scoreOutOf = helixScoreOutOf || 100;
  // Stored by a select input, so the value arrives as a string - coerce and clamp it
  var scoreDecimalPlaces = Math.min(MAX_SCORE_DECIMAL_PLACES, Math.max(0, Number(helixScoreDecimalPlaces) || 0));
  return {
    helixUIMode: helixUIMode,
    showFeedback: showFeedback,
    showScores: showScores,
    showOverallScore: showOverallScore,
    scoreOutOf: scoreOutOf,
    scoreDecimalPlaces: scoreDecimalPlaces
  };
}